import { render, staticRenderFns } from "./VendorShow.vue?vue&type=template&id=521b7580&scoped=true&"
import script from "./VendorShow.vue?vue&type=script&lang=js&"
export * from "./VendorShow.vue?vue&type=script&lang=js&"
import style0 from "./VendorShow.vue?vue&type=style&index=0&id=521b7580&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521b7580",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VRow})
